<template>
  <div class="is-main-content">
    <div class="columns">
      <div class="column ">
        <div>
          <div class="container is-fluid">
            <div class="columns">
              <div class="column is-9-fullhd is-7-desktop is-6-tablet">
                <div class="content">
                  <h3 class="level">Mes commandes et propositions</h3>
                  <a ref="lienDownload"></a>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <br>
          <div class="container is-fluid">
            <v-server-table class="fixed_header_commande"  url=""
                            :columns="columns"
                            :options="options"
                            @loaded="finLoading" @loading="debutLoading" @error="erreur" >
              <div slot="dateCommande" slot-scope="props">
                {{props.row.dateCommandeFormat}}
              </div>
              <div slot="montantHt" slot-scope="props">
                <div class="is-pulled-right">{{props.row.montantHtFormat}}</div>
              </div>
              <div slot="pdf" slot-scope="props">
                <a @click="genererPdf(props.row)">
                  <b-icon icon="download" type="is-primary"/>
                </a>
              </div>
            </v-server-table>
          </div>
        </div>
        <div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import { getCommandes, getCommandesPdf } from '@/api/commandes';
import gestionErreur from '@/services/general/gestionErreur';
import { TEXTS, PER_PAGE_VALUE, RESULTS_PER_PAGE } from '@/configuration/clientTableConf';
import { COMMANDE_ETAT, COMMANDE_CATEGORIE, COMMANDE_TYPE } from '../configuration/commandeConf';

const User = createNamespacedHelpers('user');

export default {
  name: 'index',
  data() {
    return {
      trad: {
        cmdCode: 'Code',
        cmdEtat: 'Etat',
        cmdCategorie: 'Catégorie',
        cmdType: 'Type',
        annonceur: 'Annonceur',
        dateCommande: 'Date commande',
        montantHt: 'Montant HT',
        pdf: 'Télécharger',
        emailCommercial: 'Commercial',
      },
      columns: ['cmdCode', 'cmdEtat', 'cmdCategorie', 'cmdType', 'annonceur', 'dateCommande', 'emailCommercial', 'montantHt', 'pdf'],
      loadingComponent: null,
    };
  },
  computed: {
    ...User.mapGetters({
      userEmail: 'userEmail',
    }),
    options() {
      return {
        headings: {
          cmdCode: this.trad.cmdCode,
          cmdEtat: this.trad.cmdEtat,
          cmdCategorie: this.trad.cmdCategorie,
          cmdType: this.trad.cmdType,
          annonceur: this.trad.annonceur,
          dateCommande: this.trad.dateCommande,
          emailCommercial: this.trad.emailCommercial,
          montantHt: this.trad.montantHt,
          pdf: this.trad.pdf,
        },
        perPageValues: PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        debounce: 600,
        filterByColumn: true,
        filterable: ['cmdEtat', 'cmdType', 'cmdCategorie', 'cmdCode', 'annonceur', 'montantHt', 'emailCommercial'],
        listColumns: {
          cmdEtat: COMMANDE_ETAT,
          cmdCategorie: COMMANDE_CATEGORIE,
          cmdType: COMMANDE_TYPE,
        },
        requestFunction: ((data) => {
          return getCommandes(this.userEmail, data);
        }),
        responseAdapter: ((result) => {
          result.data.forEach(cmd => {
            cmd.dateCommandeFormat = moment(cmd.dateCommande).format('DD/MM/YYYY');
            cmd.montantHtFormat = parseFloat(cmd.montantHt).toLocaleString(undefined,
              { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          });
          return {
            data: result.data,
            count: result.headers['x-total-count'],
          };
        }),
      };
    },
  },
  methods: {
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open({ container: null });
    },
    finLoading() {
      this.loadingComponent.close();
    },
    erreur() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      gestionErreur('Erreur interne');
    },
    genererPdf(data) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      getCommandesPdf(data.cmdNum, data.cmdCode, data.socCode).then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Edition_' + data.cmdCode + '.pdf';
        link.click();
        loadingComponent.close();
      }).catch((e) => {
        gestionErreur(`Erreur lors de la generation du PDF de la commande n°${data.cmdNum}`, e);
        loadingComponent.close();
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/mesOpportunites/commande/index.vue